import { motion } from "framer-motion";
import { Scissors, Sparkles, Crown, Droplet, Sparkle, Smile, Baby, Wand2 } from "lucide-react";
import { scrollTo } from "./Navbar";
import { LoyaltyCard } from "./LoyaltyPromo";

const ICONS = {
  taglio: Scissors,
  taglio_bambini: Baby,
  barba: Sparkles,
  taglio_barba: Crown,
  taglio_barba_shampoo: Crown,
  shampoo: Droplet,
  sobraciglia: Sparkle,
  sopracciglia_rasoio: Wand2,
  crema_viso: Smile,
};

export { euro } from "../lib/format";


const Services = ({ services }) => (
  <section id="servizi" data-testid="services-section" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-20 lg:py-32">
    <motion.div
      initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.6 }}
      className="mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
    >
      <div>
        <p className="text-xs sm:text-sm uppercase tracking-[0.25em] text-[#0B1F3A] font-mono-alt font-medium mb-4">Servizi & Listino</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
          <span className="gold-text">Listino</span>
        </h2>
      </div>
    </motion.div>

    <LoyaltyCard />

    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
      {services.map((s, i) => {
        const Icon = ICONS[s.id] || Scissors;
        const wide = s.popular;
        return (
          <motion.a
            key={s.id}
            href="#prenotazione"
            onClick={(e) => scrollTo(e, "#prenotazione")}
            data-testid={`service-card-${s.id}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
            className={`group relative rounded-2xl border bg-[#FFFFFF] p-6 sm:p-8 overflow-hidden hover:bg-[#F1EAE2] hover:border-[rgba(11,31,58,0.6)] hover:-translate-y-1 transition-all duration-500 ${
              wide ? "md:col-span-8 border-[rgba(11,31,58,0.6)] shadow-[0_0_40px_rgba(11,31,58,0.12)]" : "md:col-span-4 border-[rgba(11,31,58,0.2)]"
            }`}
          >
            {wide && (
              <span className="absolute top-5 right-5 rounded-full bg-[#0B1F3A] text-[#F7F2EC] text-[10px] font-bold uppercase tracking-[0.15em] px-3 py-1">
                Il Preferito
              </span>
            )}
            <Icon className="w-7 h-7 text-[#0B1F3A] mb-6 group-hover:scale-110 transition-transform duration-500" strokeWidth={1.4} />
            <div className="flex items-end justify-between gap-4">
              <div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight">{s.name}</h3>
              </div>
              <div className="text-right shrink-0">
                <p data-testid={`service-price-${s.id}`} className="font-display text-3xl sm:text-4xl font-bold gold-text">€{s.price}</p>
                <p className="text-xs text-[#6F6466] font-mono-alt mt-1">{s.duration} min</p>
              </div>
            </div>
          </motion.a>
        );
      })}
    </div>
  </section>
);

export default Services;
